webpackJsonp([58691923486625],{

/***/ 3112:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fbcampbg.5eb3d7f2.jpg";

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fbcamplogo.40f6dfb6.png";

/***/ }),

/***/ 1679:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _EventCardGrid = __webpack_require__(55);
	
	var _EventCardGrid2 = _interopRequireDefault(_EventCardGrid);
	
	var _EventCard = __webpack_require__(54);
	
	var _EventCard2 = _interopRequireDefault(_EventCard);
	
	var _EventCardZero = __webpack_require__(56);
	
	var _EventCardZero2 = _interopRequireDefault(_EventCardZero);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _fbcampbg = __webpack_require__(3112);
	
	var _fbcampbg2 = _interopRequireDefault(_fbcampbg);
	
	var _fbcamplogo = __webpack_require__(1351);
	
	var _fbcamplogo2 = _interopRequireDefault(_fbcamplogo);
	
	var _hexagons = __webpack_require__(62);
	
	var _hexagons2 = _interopRequireDefault(_hexagons);
	
	var _Search = __webpack_require__(40);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventsFBads = function (_Component) {
	  _inherits(EventsFBads, _Component);
	
	  function EventsFBads(props) {
	    _classCallCheck(this, EventsFBads);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var data = _this.props.data;
	
	    console.log(data);
	    var events = data.allContentfulEvent !== null ? data.allContentfulEvent.edges : [];
	
	    var mls = false;
	    var slug = false;
	    if (_this.props.pathContext.mls) {
	      mls = _this.props.pathContext.mls;
	    }
	    if (_this.props.pathContext.slug) {
	      slug = _this.props.pathContext.slug;
	    }
	
	    var activeEvents = [];
	    events.forEach(function (_ref) {
	      var event = _ref.node;
	
	      var datetime = new Date(event.datetime);
	      var now = new Date();
	      if (datetime < now) {
	        return;
	      }
	      if (props.pathContext.slug) {
	        if (event.slug != props.pathContext.slug) {
	          return;
	        }
	      }
	      return activeEvents.push(event);
	    });
	
	    _this.state = {
	      activeEvents: activeEvents,
	      filteredEvents: activeEvents,
	      filteredInputValue: "",
	      filteredInputValueState: '',
	      mls: mls,
	      slug: slug
	    };
	    return _this;
	  }
	
	  EventsFBads.prototype.componentDidMount = function componentDidMount() {
	    console.log("Search string");
	    console.log(this.props.location.search);
	    if (this.props.location.search.length > 4) {
	      var searchVal = '';
	      var urlpieces = this.props.location.search.replace("?", '').split('&');
	      urlpieces.forEach(function (val) {
	        if (val.substring(0, 2) == 'q=') {
	          searchVal = val.replace('q=', '');
	        }
	      });
	      searchVal = searchVal.replace(/%2C/g, ',');
	
	      //var searchVal = this.props.location.search
	      var activeEvents = this.state.activeEvents;
	
	
	      var filteredEvents = {};
	      filteredEvents = this.filterEvents(activeEvents, searchVal, 'keyword');
	      this.setState({
	        filteredInputValue: searchVal,
	        filteredEvents: filteredEvents
	      });
	    }
	  };
	
	  EventsFBads.prototype.render = function render() {
	    var classes = this.props.classes;
	    var _state = this.state,
	        activeEvents = _state.activeEvents,
	        filteredEvents = _state.filteredEvents,
	        filteredInputValue = _state.filteredInputValue,
	        mls = _state.mls,
	        slug = _state.slug;
	
	    return _react2.default.createElement(
	      "div",
	      { className: classes.root },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          "Fool-proof strategies to generate high quality buyer & seller leads with targeted Facebook ads - " + _siteConfig2.default.siteTitle
	        ),
	        _react2.default.createElement("meta", { name: "og:title", content: "Fool-proof strategies to generate high quality buyer & seller leads with targeted Facebook ads - " + _siteConfig2.default.siteTitle }),
	        _react2.default.createElement("meta", { name: "description", content: "Fool-proof strategies to generate high quality buyer & seller leads with targeted Facebook ads - " + _siteConfig2.default.siteTitle })
	      ),
	      _react2.default.createElement(_SEO2.default, { customTitle: true, customDescription: "Fool-proof strategies to generate high quality buyer & seller leads with targeted Facebook ads - " + _siteConfig2.default.siteTitle }),
	      _react2.default.createElement(
	        "div",
	        { className: classes.smBackground },
	        _react2.default.createElement(
	          _Container2.default,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: classes.titleText, style: { color: "#2d397c", paddingRight: "20px", paddingLeft: "20px" } },
	            _react2.default.createElement("img", { src: _fbcamplogo2.default, width: "100%", style: { paddingBottom: "20px", maxWidth: "450px" } }),
	            _react2.default.createElement("br", null),
	            "Fool-proof strategies to generate high quality buyer",
	            _react2.default.createElement("br", null),
	            "& seller leads with targeted Facebook ads.",
	            _react2.default.createElement("br", null),
	            "Register for this must-attend experience today...",
	            mls && _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement("br", null),
	              "exclusively for ",
	              mls,
	              " members."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.titleSubText, style: { paddingBottom: "40px", paddingRight: "20px", paddingLeft: "20px" } },
	            "Registration is FREE.   ",
	            _react2.default.createElement(
	              "span",
	              { style: { color: "#f48d07" } },
	              "Space is LIMITED."
	            ),
	            " "
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.BodyText, style: { paddingBottom: "40px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.titleSubText, style: { paddingBottom: "15px" } },
	              "Did you know the average adult spends 45+ minutes or more every single day on Facebook?"
	            ),
	            "In this session, attendees will learn the step-by-step process of creating high conversion Facebook ads",
	            _react2.default.createElement("br", null),
	            "to capture buyer and seller leads. This session is great for all levels of agent who want to learn",
	            _react2.default.createElement("br", null),
	            "how to take their Facebook advertising to the next level."
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: { backgroundColor: "#f15953", textAlign: "center", padding: "15px" } },
	        _react2.default.createElement(
	          "span",
	          { className: classes.bold, style: { color: "#ffffff", lineHeight: "20px" } },
	          "REGISTER TODAY by selecting from any upcoming date/time slots"
	        )
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        !slug && _react2.default.createElement(
	          "div",
	          { className: classes.inputWrapper },
	          _react2.default.createElement("input", {
	            className: classes.input,
	            onChange: this.onInputChange,
	            value: filteredInputValue,
	            placeholder: "Type an MLS to search... (e.g. FMLS)",
	            name: "keyword"
	          }),
	          _react2.default.createElement(_Search2.default, { size: 36, className: classes.inputIcon }),
	          _react2.default.createElement(
	            "select",
	            { className: classes.input, style: { width: "30%", marginLeft: "10px", padding: "0px" }, name: "state", onChange: this.onInputChange,
	              value: this.state.filteredInputValueState },
	            _react2.default.createElement(
	              "option",
	              null,
	              "Any State"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "AK" },
	              "AK"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "AL" },
	              "AL"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "AR" },
	              "AR"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "AZ" },
	              "AZ"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "CA" },
	              "CA"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "CO" },
	              "CO"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "CT" },
	              "CT"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "DC" },
	              "DC"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "DE" },
	              "DE"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "FL" },
	              "FL"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "GA" },
	              "GA"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "HI" },
	              "HI"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "IA" },
	              "IA"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "ID" },
	              "ID"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "IL" },
	              "IL"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "IN" },
	              "IN"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "KS" },
	              "KS"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "KY" },
	              "KY"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "LA" },
	              "LA"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "MA" },
	              "MA"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "MD" },
	              "MD"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "ME" },
	              "ME"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "MI" },
	              "MI"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "MN" },
	              "MN"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "MO" },
	              "MO"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "MS" },
	              "MS"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "MT" },
	              "MT"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "NC" },
	              "NC"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "ND" },
	              "ND"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "NE" },
	              "NE"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "NH" },
	              "NH"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "NJ" },
	              "NJ"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "NM" },
	              "NM"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "NV" },
	              "NV"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "NY" },
	              "NY"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "OH" },
	              "OH"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "OK" },
	              "OK"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "OR" },
	              "OR"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "PA" },
	              "PA"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "RI" },
	              "RI"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "SC" },
	              "SC"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "SD" },
	              "SD"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "TN" },
	              "TN"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "TX" },
	              "TX"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "UT" },
	              "UT"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "VA" },
	              "VA"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "VT" },
	              "VT"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "WA" },
	              "WA"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "WI" },
	              "WI"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "WV" },
	              "WV"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "WY" },
	              "WY"
	            )
	          )
	        ),
	        !(activeEvents && activeEvents.length) ? _react2.default.createElement(
	          _EventCardZero2.default,
	          { className: classes.grid },
	          _react2.default.createElement(
	            "div",
	            null,
	            "There are no scheduled upcoming events."
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Check back again soon."
	          )
	        ) : !(filteredEvents && filteredEvents.length) ? _react2.default.createElement(
	          _EventCardZero2.default,
	          { className: classes.grid },
	          _react2.default.createElement(
	            "div",
	            null,
	            "Oops!  Received this message in error?  Click below to view our full event list."
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "button",
	              { className: classes.resetButton, onClick: this.onInputClear },
	              "Show ALL Upcoming Events"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { marginTop: '20px' } },
	            "No local events in your area at the moment? Click below to connect with one of our Success Coaches instead."
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/get-started", className: classes.resetButton },
	              "Speak to an Elevate Coach"
	            )
	          )
	        ) : _react2.default.createElement(
	          _EventCardGrid2.default,
	          { className: classes.grid },
	          filteredEvents.map(function (event) {
	            return _react2.default.createElement(_EventCard2.default, { key: event.id, event: event });
	          })
	        )
	      )
	    );
	  };
	
	  return EventsFBads;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onInputChange = function (e) {
	    console.log(e.target.name);
	    var value = e.target.value;
	    var activeEvents = _this2.state.activeEvents;
	
	
	    var filteredEvents = {};
	
	    if (e.target.name == 'keyword') {
	      filteredEvents = _this2.filterEvents(activeEvents, value, 'keyword');
	      _this2.setState({
	        filteredInputValue: value
	      });
	    }
	    if (e.target.name == 'state') {
	      filteredEvents = filteredEvents = _this2.filterEvents(activeEvents, value, 'state');
	      _this2.setState({
	        filteredInputValueState: value
	      });
	    }
	
	    _this2.setState({
	      filteredEvents: filteredEvents
	    });
	  };
	
	  this.onInputClear = function () {
	    var activeEvents = _this2.state.activeEvents;
	
	    _this2.setState({
	      filteredEvents: activeEvents,
	      filteredInputValue: "",
	      filteredInputValueState: ""
	    });
	  };
	
	  this.filterEvents = function (events, keyword) {
	    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "keyword";
	
	    var filteredEvents = events;
	    if (type === 'keyword') {
	
	      var values = keyword.split(",");
	
	      filteredEvents = events.filter(function (event) {
	        // Check the input string against the event title and location
	        var toReturn = false;
	        values.forEach(function (value) {
	          if (value.length > 1) {
	            if (event.title && event.title.toLowerCase().includes(value.toLowerCase()) || event.location && event.location.toLowerCase().includes(value.toLowerCase()) || event.mls && event.mls.toLowerCase().includes(value.toLowerCase())) {
	              toReturn = true;
	            }
	          }
	        });
	
	        return toReturn;
	      });
	    }
	    if (type === 'state') {
	      filteredEvents = events.filter(function (event) {
	        if (event.state && event.state.toLowerCase().includes(keyword.toLowerCase()) || event.state && keyword === 'Any State') {
	          return true;
	        }
	        return false;
	      });
	    }
	
	    return filteredEvents;
	  };
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _column, _logoStyle;
	
	  return {
	    root: {
	      position: "relative",
	      paddingTop: "20px",
	      paddingBottom: "30px"
	    },
	    top: {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "center"
	    },
	    top2: {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "top"
	    },
	    column3: (_column = {
	      width: "100%",
	      maxWidth: "100%",
	      paddingRight: "13px",
	      paddingLeft: "13px",
	      verticalAlign: "top"
	    }, _column[theme.breakpoints[900]] = {
	      width: "350px"
	    }, _column),
	    heading: {
	      fontSize: "32px",
	      fontWeight: "700",
	      marginRight: "auto"
	    },
	    bold: {
	      fontWeight: "700"
	    },
	    bootcampLink: {
	      color: "inherit",
	      textDecoration: "none",
	      padding: "12px 0",
	
	      "&:hover": {
	        textDecoration: "underline"
	      }
	    },
	    inputWrapper: {
	      position: "relative",
	      display: "flex",
	      alignItems: "center",
	      maxWidth: "600px",
	      margin: "64px auto 0"
	    },
	    input: {
	      display: "flex",
	      width: "100%",
	      height: "52px",
	      border: "1px solid rgba(100, 97, 110, .36)",
	      color: "#64616E",
	      fontSize: "16px",
	      fontFamily: "inherit",
	      fontWeight: "600",
	      borderRadius: "4px",
	      padding: "18px 48px 18px 12px"
	    },
	    inputIcon: {
	      position: "absolute",
	      top: "0",
	      right: "140px",
	      color: "rgba(100, 97, 110, .36)",
	      margin: "8px"
	    },
	    resetButton: {
	      fontFamily: "inherit",
	      fontWeight: "600",
	      backgroundColor: "#55c3ba",
	      textDecoration: "none",
	      borderRadius: "6px",
	      padding: "12px",
	      paddingRight: "24px",
	      paddingLeft: "24px",
	      marginTop: "24px",
	      color: "#FFFFFF"
	    },
	    grid: {
	      marginTop: "32px"
	    },
	
	    logoStyle: (_logoStyle = {
	      width: "80%"
	    }, _logoStyle[theme.breakpoints[900]] = {
	      width: "40%"
	    }, _logoStyle),
	
	    titleText: {
	      fontSize: "24px",
	      lineHeight: "33px",
	      fontWeight: "700",
	      textAlign: "center",
	      color: "#55c3ba",
	      paddingBottom: "18px",
	      paddingTop: "40px"
	    },
	
	    titleSubText: {
	      fontSize: "18px",
	      lineHeight: "24px",
	      fontWeight: "700",
	      textAlign: "center",
	      color: "#2c73ba"
	    },
	
	    BodyText: {
	      fontSize: "16px",
	      lineHeight: "25px",
	      fontWeight: "300",
	      textAlign: "center",
	      color: "#56585a",
	      paddingRight: "45px",
	      paddingLeft: "45px"
	    },
	
	    smBackground: {
	      backgroundImage: "url('" + _fbcampbg2.default + "')",
	      backgroundPosition: "middle",
	      width: "100%"
	    },
	    videoEmbed: {
	      position: "relative",
	      paddingBottom: "56.25%",
	      paddingTop: "30px",
	      height: "0",
	      overflow: "hidden"
	
	    },
	    videoContainer: {
	      position: "absolute",
	      top: "0",
	      left: "0",
	      width: "100%",
	      height: "100%"
	
	    }
	  };
	})(EventsFBads);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-fbads-js-3c92e7a513fc127593aa.js